import { useState } from "react";
import { ArrowRight } from "lucide-react";
import logo from "../assets/truviq-logo.png";
import footer_bg from "../assets/images/footer_bg-2.png"
import { Link } from "react-router-dom";
const ABOUT_LINKS = [
  { name: "Vision, Mission & Values", href: "/about" },
  { name: "Why Choose Us", href: "/about" },
  { name: "Our Team", href: "/about" },
  { name: "Location", href: "/about" },
];

const SERVICES_LINKS = [
  { name: "Camunda Implementation", href: "/capabilities/camunda" },
  { name: "Prior Health Authorization", href: "/industries/healthcare/prior-auth" },
  { name: "Legacy Modernization", href: "/" },
];

const RESOURCES_LINKS = [
  { name: "Blogs", href: "/blogs" },
  { name: "Events", href: "/events" },
  { name: "Case Studies", href: "/case-studies" },
];

const CAREERS_LINKS = [
  { name: "Our Culture", href: "/" },
  { name: "Current Openings", href: "/" },
];

const SOCIAL_LINKS = [
  { name: "Linkedin", href: "/" },
  { name: "Instagram", href: "/" },
  { name: "Facebook", href: "/" },
  { name: "𝕏", href: "/" },
  { name: "Email", href: "/" },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    setEmail("");
  };

  return (
    <footer className="relative w-full bg-[#000036] text-slate-300 overflow-hidden border-t border-slate-800">
      <div className="top-0 right-0 absolute opacity-50  h-full pointer-events-none"> 
        <img src={footer_bg} alt=""/>
      </div>
      <div className="border-b border-slate-800 ">
        <div className="mx-auto lg:w-3/4 px-6 lg:px-12 py-12 lg:py-16 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <Link to="/" className="lg:col-span-4 flex items-center  gap-3">
            <img src={logo} alt="Truviq Logo" className="md:w-1/2 w-2/3" />
          </Link>

          <div className="lg:col-span-8">
            <p className="text-sm sm:text-base leading-relaxed text-slate-300 font-normal">
              Truviq drives enterprise transformation through intelligent
              automation, AI-driven decisioning, and workflow orchestration.
              With deep expertise in platforms like{" "}
              <strong className="text-white font-semibold">Pega</strong>,{" "}
              <strong className="text-white font-semibold">ServiceNow</strong>,
              and <strong className="text-white font-semibold">Camunda</strong>,
              we deliver scalable solutions in Low-Code, DPA, and Intelligent
              Document Processing. Trusted by global enterprises, we help
              streamline operations, enhance customer experiences, and build
              future-ready businesses.
            </p>
          </div>
        </div>
      </div>
      <div className="border-b border-slate-800">
        <div className="mx-auto lg:w-3/4 px-6 lg:px-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y sm:divide-y-0 sm:divide-x divide-slate-800">
            <div className="py-5 lg:py-12 sm:pr-8 first:pl-0">
              <h4 className="font-display text-sm font-bold text-white tracking-wide mb-5">
                About Us
              </h4>
              <ul className="space-y-3">
                {ABOUT_LINKS.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-xs sm:text-sm text-slate-300 hover:text-white transition-colors block"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="py-5 lg:py-12 sm:px-8">
              <h4 className="font-display text-sm font-bold text-white tracking-wide mb-5">
                Services
              </h4>
              <ul className="space-y-3">
                {SERVICES_LINKS.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-xs sm:text-sm text-slate-300 hover:text-white transition-colors block"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="py-5 lg:py-12 sm:px-8">
              <h4 className="font-display text-sm font-bold text-white tracking-wide mb-5">
                Resources
              </h4>
              <ul className="space-y-3">
                {RESOURCES_LINKS.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-xs sm:text-sm text-slate-300 hover:text-white transition-colors block"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="py-5 lg:py-12 sm:pl-8 last:pr-0">
              <h4 className="font-display text-sm font-bold text-white tracking-wide mb-5">
                Careers
              </h4>
              <ul className="space-y-3">
                {CAREERS_LINKS.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-xs sm:text-sm text-slate-300 hover:text-white transition-colors block"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="border-b border-slate-800 ">
        <div className="mx-auto lg:w-3/4 px-6 lg:px-12 py-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <h4 className="text-sm font-bold text-white tracking-wide">
              Subscribe our newsletter
            </h4>
            <p className="text-sm text-slate-400 mt-0.5">
              Stay updated with our latest news and enterprise insights.
            </p>
          </div>

          <form
            onSubmit={handleSubscribe}
            className="w-full md:w-auto flex items-center gap-2"
          >
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              className="w-full sm:w-72 px-4 py-2.5 rounded-full bg-slate-900/80 border border-slate-700 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-slate-500 transition-colors"
            />
         
            <button
             type="submit"
              aria-label="Subscribe"
              className="group relative h-10 px-4 inline-flex items-center justify-between sm:gap-3  rounded-full border border-black/15  bg-white hover:border-white/40 text-slate-900 font-mono text-xs font-semibold uppercase tracking-widest transition-all duration-300 hover:bg-slate-950 hover:text-white hover:shadow-lg"
             
            >
              <span>Subscribe</span>
              <div className="h-7 w-7 rounded-full bg-white/10 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1  group-hover:bg-white group-hover:text-slate-950">
                <ArrowRight size={14} />
              </div>
            </button>
          </form>
        </div>
      </div>
      <div className="mx-auto lg:w-3/4 px-6 lg:px-12 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-sm text-slate-400">
          <div className="flex flex-wrap items-center gap-6">
            {SOCIAL_LINKS.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-slate-300 hover:text-white transition-colors"
              >
                {item.name}
              </a>
            ))}
           
          </div>
          <div className="flex items-center gap-6">
            <p>Copyright © 2026, All rights reserved by Truviq.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
